import logo from "@/assets/rkd-logo.png";
import { Phone, Mail, Facebook } from "lucide-react";
import { openBooking } from "./openBooking";

export function Footer() {
  return (
    <footer className="bg-ink text-cream/80 border-t border-cream/10">
      <div className="container-prose py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={logo} alt="RKD Tile" className="h-12 w-auto" width={48} height={48} loading="lazy" fetchPriority="low" />
            <div>
              <div className="font-display text-xl text-cream">RKD Tile</div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-accent">Custom Tile · Est. 1996</div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed">
            Over 25 years of exceptional tile craftsmanship for Utah's most discerning homeowners and builders.
            BBB A+ rated. Licensed and insured. Long-term relationships, built one project at a time.
          </p>
          <a
            href="https://www.facebook.com/rkdtile"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 text-sm text-cream/70 hover:text-accent transition-colors"
          >
            <Facebook className="h-4 w-4" /> Follow on Facebook
          </a>
        </div>
        <div>
          <h3 className="font-display text-cream text-sm tracking-widest uppercase mb-4">Service Areas</h3>
          <ul className="space-y-2 text-sm">
            <li>West Jordan, UT</li>
            <li>Sandy, UT</li>
            <li>Taylorsville, UT</li>
            <li>Draper, UT</li>
            <li>Park City, UT</li>
            <li>Greater Salt Lake City</li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-cream text-sm tracking-widest uppercase mb-4">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li><a href="tel:8015982226" className="flex items-center gap-2 hover:text-accent"><Phone className="h-4 w-4" /> (801) 598-2226</a></li>
            <li><a href="mailto:rkdtile@msn.com" className="flex items-center gap-2 hover:text-accent break-all"><Mail className="h-4 w-4" /> rkdtile@msn.com</a></li>
          </ul>
          <button
            type="button"
            onClick={openBooking}
            className="mt-5 inline-flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 text-xs font-semibold tracking-[0.18em] uppercase hover:bg-accent/90 transition-colors"
          >
            Schedule Consultation
          </button>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="container-prose py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-cream/60">
          <div>© {new Date().getFullYear()} RKD Tile · Licensed & Insured · BBB A+ Rated</div>
          <div className="flex gap-6"><span>Tile Contractor Park City</span><span>Shower Repair Salt Lake</span><span>Custom Tile Utah</span></div>
        </div>
      </div>
    </footer>
  );
}
